export const removeSpecialChars = (string) => {
  const formattedString = string.replace(/#|%|&/g, '');
  return formattedString;
};
